module.exports = function() {
  return new Worker(__webpack_public_path__ + "3007295bf1c9d5dde6c5.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/workers/country/index.worker.js
// module id = L6Ou
// module chunks = 1